import { Avatar } from "@fluentui/react-components";
import { GoHome } from "react-icons/go";
import { CommonInfo } from "../../CommonData/Config";
import "./CurrentBookingUser.css";

type CurrentBookingUserProps = {
    theme: string;
    userName: string;
    userImage: string;
    worklocationIcon: string;
    isOrganiser?: boolean;
    onClose: () => void;
}

const CurrentBookingUser = ({
    theme,
    userName,
    userImage,
    worklocationIcon,
    isOrganiser = false,
    onClose
}: CurrentBookingUserProps) => {

    return (
        <>
            <div className="currentBookingUsercontainer">
                <div className="avatar">
                    <Avatar
                        name={userName}
                        image={{
                            src: userImage,
                        }}
                        style={{
                            cursor: "pointer", width: "30px", height: "30px"
                        }}
                        shape="circular"
                    />
                </div>
                <div className="name">
                    <span style={{ fontSize: 13, fontWeight: 400, fontStyle: "normal" }}>{userName}</span>
                </div>
                {isOrganiser ? (
                    <div style={{width: "22px", height: "22px"}}>
                    {worklocationIcon !== "" && (<img src={`${CommonInfo.folderName}${worklocationIcon}`} />)}
                    </div>
                ) : (
                    <div className="icContainer">
                    <div style={{width: "22px", height: "22px"}}>
                    {worklocationIcon !== "" && (<img src={`${CommonInfo.folderName}${worklocationIcon}`} />)}
                    </div>
                    <img src={`${CommonInfo.folderName}${theme === 'dark' ? '/checkoutlight.svg' : '/checkout.svg'}`} width={20} height={20} className="closeIc" onClick={() => onClose()}/>
                </div>
                )}
            </div>
        </>
    );
};

export default CurrentBookingUser;